<template>
    <div class="user-tab-panel">
        <v-row>
            <v-col cols="12">
                <v-select
                    v-model="payload.role"
                    label="Tipo de usuário"
                    outlined
                    hide-details="auto"
                    item-text="text"
                    item-value="value"
                    disabled
                    :items="$user.roles"
                />
            </v-col>

            <v-col cols="12">
                <v-text-field
                    autocomplete="nope"
                    v-model="payload.name"
                    label="Nome"
                    outlined
                    hide-details="auto"
                />
            </v-col>

            <v-col cols="12">
                <v-text-field
                    autocomplete="nope"
                    v-model="payload.email"
                    label="E-mail"
                    outlined
                    hide-details="auto"
                />
            </v-col>

            <v-col
                cols="12"
                v-if="['user', 'partner'].includes(payload.role)"
            >
                <v-autocomplete
                    multiple
                    v-model="generalPermissionSelection"
                    label="Permissões"
                    outlined
                    hide-details="auto"
                    item-text="name"
                    item-value="id"
                    :items="generalPermissions"
                />
            </v-col>

            <template v-if="payload.role === 'user'">
                <v-col v-if="$store.state.currentUser?.role === 'admin'" cols="12">
                    <glass-panel radius="md" class="pa-4">
                        <eyebrow strong>Funcionalidades dos planos</eyebrow>
                        <p class="text-caption mt-2">As exceções manuais prevalecem sobre as assinaturas, inclusive após cancelamento.</p>
                        <div v-for="feature in managedFeatures" :key="feature.id" class="mb-4">
                            <v-select v-model="payload.subscription_feature_overrides.permissions[feature.id]" :items="overrideModes"
                                :label="feature.name" outlined hide-details="auto" />
                            <div class="text-caption mt-1">
                                Acesso atual: {{ user.permissions?.includes(feature.id) ? 'Liberado' : 'Sem acesso' }} ·
                                {{ featureSources(feature.id) }}
                            </div>
                        </div>
                        <v-text-field v-model.number="payload.subscription_feature_overrides.geo_seo_prompt_limit" type="number" min="1" step="1"
                            clearable label="Exceção para o limite de prompts" outlined hide-details="auto"
                            hint="Vazio usa o maior limite dos planos; liberação manual sem plano permite 1 prompt. Reduções pausam excedentes." persistent-hint />
                        <div class="text-caption mt-2">Limite contratado: {{ user.subscription_feature_summary?.contracted_geo_seo_prompt_limit ?? 0 }} ·
                            Limite efetivo atual: {{ user.geo_seo_prompt_limit ?? 0 }}</div>
                    </glass-panel>
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        autocomplete="nope"
                        type="number"
                        v-model="payload.articles_quantity"
                        label="Saldo de artigos"
                        outlined
                        hide-details="auto"
                    />
                </v-col>

                <v-col
                    cols="12"
                    v-if="payload.permissions?.includes('SOCIAL_NETWORK_ASSISTANT')"
                >
                    <v-text-field
                        autocomplete="nope"
                        type="number"
                        v-model="payload.social_post_quantity"
                        label="Saldo de postagens sociais"
                        outlined
                        hide-details="auto"
                    />
                </v-col>

                <v-col cols="12">
                    <r-server-autocomplete
                        v-model="payload.vindi_customer_id"
                        autocomplete="nope"
                        label="Cliente Vindi"
                        outlined
                        hide-details="auto"
                        request="searchVindiCustomers"
                        initial-value-request="getVindiCustomerById"
                        item-text="email"
                        item-value="id"
                        clearable
                    >
                        <template #selection="{ item, attrs }">
                            <v-list-item-content v-bind="attrs">
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                <v-list-item-subtitle>ID: {{ item.id }} - Email: {{ item.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                        <template #item="{ item, attrs }">
                            <v-list-item-content v-bind="attrs">
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                <v-list-item-subtitle>ID: {{ item.id }} - Email: {{ item.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </r-server-autocomplete>
                </v-col>

                <v-col cols="12">
                    <v-text-field
                        autocomplete="nope"
                        v-model="payload.vindi_subscription_id"
                        label="ID Assinatura Vindi"
                        readonly
                        outlined
                        hide-details="auto"
                    />
                </v-col>
                <v-col cols="12">
                    <v-autocomplete
                        v-model="payload.vindi_subscription_id"
                        :items="subscriptions"
                        label="Atribuir Assinatura Vindi"
                        outlined
                        hide-details="auto"
                        item-text="customer.email"
                        item-value="id"
                    >
                        <template #selection="{ item, attrs }">
                            <v-list-item-content v-bind="attrs">
                                <v-list-item-title>{{ item.customer.email }}</v-list-item-title>
                                <v-list-item-subtitle>ID: {{ item.id }} - Plano: {{ item.plan.name }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                        <template #item="{ item, attrs }">
                            <v-list-item-content v-bind="attrs">
                                <v-list-item-title>{{ item.customer.email }}</v-list-item-title>
                                <v-list-item-subtitle>ID: {{ item.id }} - Plano: {{ item.plan.name }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                </v-col>
            </template>

            <v-col cols="12">
                <v-text-field
                    autocomplete="nope"
                    v-model="payload.duda_site_name"
                    label="ID do site Duda"
                    outlined
                    hide-details="auto"
                />
            </v-col>

            <v-col
                cols="12"
                v-if="payload.role === 'partner'"
            >
                <v-autocomplete
                    autocomplete="nope"
                    v-model="payload.accesses"
                    label="Acessos"
                    :items="users.filter(user => user.role === 'user')"
                    item-text="name"
                    item-value="_id"
                    multiple
                    outlined
                    hide-details="auto"
                >
                    <template #item="{ item, attrs }">
                        <v-list-item-content v-bind="attrs">
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                    <template #selection="{ item, index }">
                        <div v-if="index === 0">
                            <span>{{ item.name }}</span>
                        </div>
                        <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                        >
                            (+{{ payload.accesses.length - 1 }} outros)
                        </span>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>

        <div class="user-tab-panel__actions">
            <v-btn
                color="primary"
                @click="save"
                :loading="saving"
            >
                Salvar
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            saving: false,
            payload: {},
            managedFeatures: [
                { id: 'CONVERSATION_ANALYSIS', name: 'Análise de atendimentos' },
                { id: 'GEO_SEO_PRESENCE', name: 'Presença GEO e SEO' },
                { id: 'GOOGLE_BUSINESS_PROFILE', name: 'Perfil no Google' },
            ],
            overrideModes: [{ text: 'Herdar dos planos', value: 'inherit' }, { text: 'Liberar manualmente', value: 'allow' }, { text: 'Bloquear manualmente', value: 'deny' }],
        }
    },
    computed: {
        generalPermissionSelection: {
            get() { return this.payload.role === 'user' ? (this.payload.permissions || []).filter(p => !this.managedFeatures.some(f => f.id === p)) : this.payload.permissions },
            set(value) {
                const managed = this.payload.role === 'user' ? (this.payload.permissions || []).filter(p => this.managedFeatures.some(f => f.id === p)) : []
                this.$set(this.payload, 'permissions', [...managed, ...value])
            },
        },
        generalPermissions() {
            return this.payload.role === 'user' ? this.$user.permissions.filter(p => !this.managedFeatures.some(f => f.id === p.id)) : this.$user.permissions
        },
        user: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        users() {
            return this.$store.state.users.data
        },
        subscriptions() {
            return this.$store.state.vindiSubscriptions.data
        },

    },
    methods: {
        featureSources(feature) {
            const sources = (this.user.subscription_feature_summary?.sources || [])
                .filter(s => s.feature_permissions.includes(feature))
                .map(s => `Plano Vindi ${s.plan_id}, assinatura ${s.subscription_id}${feature === 'GEO_SEO_PRESENCE' ? `: ${s.geo_seo_prompt_limit} prompts` : ''} (${this.sourceStatus(s.status)})`)
            return sources.join(', ') || 'Sem concessão de assinatura'
        },
        sourceStatus(status) { return { eligible: 'elegível', overdue: 'em atraso', canceled: 'cancelada', future: 'futura', pending: 'sem pagamento', inactive: 'encerrada' }[status] || status },
        async load() {
            const payload = JSON.parse(JSON.stringify(this.value || {}))

            payload.accesses = payload.accesses?.map(access => access.user_id) || []
            payload.geo_seo_prompt_limit = payload.geo_seo_prompt_limit ?? 1
            payload.subscription_feature_overrides = payload.subscription_feature_overrides || {
                permissions: Object.fromEntries(this.managedFeatures.map(f => [f.id, payload.permissions?.includes(f.id) ? 'allow' : 'inherit'])),
                geo_seo_prompt_limit: payload.permissions?.includes('GEO_SEO_PRESENCE') ? payload.geo_seo_prompt_limit : null,
            }

            this.payload = payload

            if (!this.users.length) {
                await this.$store.dispatch('users/load')
            }

            if (!this.subscriptions.length) {
                await this.$store.dispatch('vindiSubscriptions/load')
            }
        },
        async save() {
            this.saving = true
            const data = JSON.parse(JSON.stringify(this.payload))
            delete data.subscription_feature_summary
            delete data.subscription_features_initialized

            data.accesses = data.accesses || []
            data.accesses = data.accesses.map(access => ({
                user_id: access,
            }))


            const response = await this.$api.updateUser({
                id: this.user._id,
                data
            })

            if (response.error) {
                this.saving = false
                return
            }
            const refreshed = await this.$api.getUserById({ id: this.user._id })
            if (!refreshed.error) this.user = refreshed.message
            await this.$store.dispatch('loadCurrentUser')

            setTimeout(() => {
                this.saving = false
                this.$toast('success', 'Usuário atualizado com sucesso!')
            }, 1000)
        },
    },
    watch: {
        value: {
            immediate: true,
            handler: 'load'
        }
    },

}
</script>

<style scoped>
.user-tab-panel__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}
</style>
